import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=5465a67c&scoped=true&"
import script from "./js/modal.js?vue&type=script&lang=js&"
export * from "./js/modal.js?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=5465a67c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465a67c",
  null
  
)

export default component.exports